import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import vueAxios from 'vue-axios'
import axios from 'axios'
import utils from './utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import 'social-share.js/dist/css/share.min.css'
import ElementUI from 'element-ui'
import { message  } from '@/components/common/overrideMessage'
import 'element-ui/lib/theme-chalk/index.css'
import zhValidationMessages from 'vee-validate/dist/locale/zh_CN'
import enValidationMessages from 'vee-validate/dist/locale/en'
import VeeValidate, { Validator } from 'vee-validate'
//import VueAnalytics from 'vue-analytics'
import VueGtag from "vue-gtag"

Vue.use(vueAxios, axios)
Vue.use(utils)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VeeValidate, {
   i18nRootKey: 'validations', // customize the root path for validation messages.
   i18n,
   dictionary: {
    zh: zhValidationMessages,
    en: enValidationMessages
   }
})
Vue.use(VueGtag, {
    config: { id: 'G-0BNNX6VTHM',
              params: { send_page_view: true } }
}, router)

Vue.config.productionTip = false

Vue.filter('dateFormat', function (input, pattern, lang) {
  if (lang === 'zh')
    moment.locale('zh-cn')
  else
    moment.locale(lang)
  if (pattern === 'from') {
    if (moment(input).add(30, 'day') > moment())
      return moment(input).fromNow()
    else
      return '1个月前'
  } else
    return moment(input).format(pattern)
})

Vue.filter('dateFormat1', function (input, pattern, lang) {
  if (lang === 'zh')
    moment.locale('zh-cn')
  else
    moment.locale(lang)
  if (pattern === 'from') {
    if (moment(input).add(7, 'day') > moment())
      return moment(input).fromNow()
    else
      return '1周前'
  } else
    return moment(input).format(pattern)
})

router.beforeEach((to, from, next) => {
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    if (to.path === '/jobs') {
      window.location = 'https://www.accacnjobs.com/#/s.html'
    } else if (to.path === '/my_applications') {
      window.location = 'https://www.accacnjobs.com/#/app-history.html'
    } else if (to.path.indexOf('/jobs/') != -1) {
      let jobId = to.path.replace('/jobs/', '')
      window.location = 'https://www.accacnjobs.com/#/vacancy.html?id=' + jobId
    } else {
      next()
    }
  } else {
    next()
  }
})

Vue.prototype.$message = message

Vue.prototype.SITE_URL = 'https://www.accacnjobs.com/#/vacancy.html?id='
Vue.prototype.HR_URL = 'https://www.accacnjobs.com/#/vacancy.html?id='
Vue.prototype.IMG_PREFIX = '/static/upload_files/'

//Prod
Vue.prototype.API_PREFIX = ''
Vue.prototype.API3_PREFIX = '/api3/'
Vue.prototype.BLOG_API_PREFIX = '/careers/api/'


//Vue.prototype.STATIC_URL = 'http://sys.element-resources.com/images/'

new Vue({
  data: { params: null },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
